import tinycolor from "tinycolor2";

export const getNodeColor = (nodeColor, textColor) => {
  return {
    fill: tinycolor(nodeColor).desaturate(5).toString(),
    stroke: tinycolor(nodeColor).desaturate(5).lighten(5).toString(),
    text: textColor,
  };
};

export const getNodeColorFill = (nodeColor) =>
  tinycolor(nodeColor).desaturate(5).toString();
